// Generated by `yarn tokens:import` from a figma_get_text_styles export. Do not edit.
//
// Read through the Desktop Bridge, not through search_design_system: the published
// library surface for this file is stale, so its style names carry a +1 offset and its
// sizes (51.95, 36.49, 22.78, …) are not the ones the file uses. The values below are
// the ones bound to the size/* and line-height/* variables — the 4px-grid-snapped scale.
//
// `classes` is materialised rather than computed at runtime because Tailwind extracts
// class candidates from source text. A class assembled from a template literal is never
// seen by the scanner, so its rule is never emitted and the element silently falls back
// to react-native-web's 14px default.

export type FigmaTextStyle = {
    id: string
    alias: string
    family: string
    size: number
    lineHeight: number
    weight: 'Regular' | 'Medium' | 'SemiBold'
    upper?: true
    classes: string
}

export const typographyStyles = {
    'd1-regular': {
        id: 'S:904a063356a39dd0d1d4fdd7560157cec5809cea,',
        alias: 'Display Data/D1-Regular',
        family: 'Manrope',
        size: 52,
        lineHeight: 64,
        weight: 'Regular',
        classes: 'text-[3.25rem] leading-[4rem] font-regular',
    },
    'd1-medium': {
        id: 'S:a181819ec54c6b59ee4ebd3a6a3b4ea2320f07f2,',
        alias: 'Display Data/D1-Medium',
        family: 'Manrope',
        size: 52,
        lineHeight: 64,
        weight: 'Medium',
        classes: 'text-[3.25rem] leading-[4rem] font-medium',
    },
    'd2-regular': {
        id: 'S:3b8ed0d6061e807aeed3f3ac94251a119a3d68ec,',
        alias: 'Display Data/D2-Regular',
        family: 'Manrope',
        size: 36,
        lineHeight: 44,
        weight: 'Regular',
        classes: 'text-[2.25rem] leading-[2.75rem] font-regular',
    },
    'd2-medium': {
        id: 'S:baa99362c3b1a54392be1378eb49ac7101dd2d96,',
        alias: 'Display Data/D2-Medium',
        family: 'Manrope',
        size: 36,
        lineHeight: 44,
        weight: 'Medium',
        classes: 'text-[2.25rem] leading-[2.75rem] font-medium',
    },
    'd3-regular': {
        id: 'S:3efa57d9266cd184c32ac07ac6394f1773fb3341,',
        alias: 'Display Data/D3-Regular',
        family: 'Manrope',
        size: 32,
        lineHeight: 40,
        weight: 'Regular',
        classes: 'text-[2rem] leading-[2.5rem] font-regular',
    },
    'd3-medium': {
        id: 'S:505c4c20767000e6a630ef40403e156e8a3cca54,',
        alias: 'Display Data/D3-Medium',
        family: 'Manrope',
        size: 32,
        lineHeight: 40,
        weight: 'Medium',
        classes: 'text-[2rem] leading-[2.5rem] font-medium',
    },
    'd4-regular': {
        id: 'S:2321ac1f65c7a5ed182d197231f134ed42287d2d,',
        alias: 'Display Data/D4-Regular',
        family: 'Manrope',
        size: 23,
        lineHeight: 28,
        weight: 'Regular',
        classes: 'text-[1.4375rem] leading-[1.75rem] font-regular',
    },
    'd4-medium': {
        id: 'S:7b19dc5ee466577562d11993d65aab4dbc34e66f,',
        alias: 'Display Data/D4-Medium',
        family: 'Manrope',
        size: 23,
        lineHeight: 28,
        weight: 'Medium',
        classes: 'text-[1.4375rem] leading-[1.75rem] font-medium',
    },
    'h1-regular': {
        id: 'S:7128ca49edc77e1b4cfbcf2d61aa135d736752a2,',
        alias: 'Display Data/Header/H1-Regular',
        family: 'Manrope',
        size: 18,
        lineHeight: 24,
        weight: 'Regular',
        classes: 'text-[1.125rem] leading-[1.5rem] font-regular',
    },
    'h1-medium': {
        id: 'S:6a5ae6361b69670945757bd35631d7426ccd3273,',
        alias: 'Display Data/Header/H1-Medium',
        family: 'Manrope',
        size: 18,
        lineHeight: 24,
        weight: 'Medium',
        classes: 'text-[1.125rem] leading-[1.5rem] font-medium',
    },
    'p1-regular': {
        id: 'S:951e86eed2678091c373ab50c6cceb638c129b9d,',
        alias: 'Paragraph/P1-Regular',
        family: 'Manrope',
        size: 16,
        lineHeight: 24,
        weight: 'Regular',
        classes: 'text-[1rem] leading-[1.5rem] font-regular',
    },
    'p1-medium': {
        id: 'S:e819ac66dc05a21073bd26e92f5c31882b25a6a9,',
        alias: 'Paragraph/P1-Medium',
        family: 'Manrope',
        size: 16,
        lineHeight: 24,
        weight: 'Medium',
        classes: 'text-[1rem] leading-[1.5rem] font-medium',
    },
    'p1-semibold': {
        id: 'S:91da6281f45eb14bcbe428007681734246041b01,',
        alias: 'Paragraph/P1-SemiBold',
        family: 'Manrope',
        size: 16,
        lineHeight: 24,
        weight: 'SemiBold',
        classes: 'text-[1rem] leading-[1.5rem] font-semiBold',
    },
    'p2-regular': {
        id: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
        alias: 'Paragraph/P2-Regular',
        family: 'Manrope',
        size: 14,
        lineHeight: 20,
        weight: 'Regular',
        classes: 'text-[0.875rem] leading-[1.25rem] font-regular',
    },
    'p2-medium': {
        id: 'S:dc8849474e775e3c3f189ea31a5d655eca473208,',
        alias: 'Paragraph/P2-Medium',
        family: 'Manrope',
        size: 14,
        lineHeight: 20,
        weight: 'Medium',
        classes: 'text-[0.875rem] leading-[1.25rem] font-medium',
    },
    'p2-semibold': {
        id: 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
        alias: 'Paragraph/P2-SemiBold',
        family: 'Manrope',
        size: 14,
        lineHeight: 20,
        weight: 'SemiBold',
        classes: 'text-[0.875rem] leading-[1.25rem] font-semiBold',
    },
    'p3-regular': {
        id: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
        alias: 'Paragraph/P3-Regular',
        family: 'Manrope',
        size: 13,
        lineHeight: 20,
        weight: 'Regular',
        classes: 'text-[0.8125rem] leading-[1.25rem] font-regular',
    },
    'p3-medium': {
        id: 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
        alias: 'Paragraph/P3-Medium',
        family: 'Manrope',
        size: 13,
        lineHeight: 20,
        weight: 'Medium',
        classes: 'text-[0.8125rem] leading-[1.25rem] font-medium',
    },
    'p3-semibold': {
        id: 'S:6f95766c626639c89a4378f1339bf1523ebeac7e,',
        alias: 'Paragraph/P3-SemiBold',
        family: 'Manrope',
        size: 13,
        lineHeight: 20,
        weight: 'SemiBold',
        classes: 'text-[0.8125rem] leading-[1.25rem] font-semiBold',
    },
    'ac2-regular': {
        id: 'S:59ec626d0811645283cce2fd583b9d8eac76a3fd,',
        alias: 'ALL CAPS/AC2-Regular',
        family: 'Manrope',
        size: 14,
        lineHeight: 20,
        weight: 'Regular',
        upper: true,
        classes: 'text-[0.875rem] leading-[1.25rem] font-regular uppercase',
    },
    'ac2-medium': {
        id: 'S:384a8a249e2da3b6f84a47f383dde493ec89d188,',
        alias: 'ALL CAPS/AC2-Medium',
        family: 'Manrope',
        size: 14,
        lineHeight: 20,
        weight: 'Medium',
        upper: true,
        classes: 'text-[0.875rem] leading-[1.25rem] font-medium uppercase',
    },
    'ac3-regular': {
        id: 'S:a002b322038c8354f17a39bacb59a5b2d5c6c641,',
        alias: 'ALL CAPS/AC3-Regular',
        family: 'Manrope',
        size: 13,
        lineHeight: 20,
        weight: 'Regular',
        upper: true,
        classes: 'text-[0.8125rem] leading-[1.25rem] font-regular uppercase',
    },
    'ac3-medium': {
        id: 'S:c74d435f2dad0a0128a68ae839dd0ad1c455d469,',
        alias: 'ALL CAPS/AC3-Medium',
        family: 'Manrope',
        size: 13,
        lineHeight: 20,
        weight: 'Medium',
        upper: true,
        classes: 'text-[0.8125rem] leading-[1.25rem] font-medium uppercase',
    },
} as const satisfies Record<string, FigmaTextStyle>
